import React from "react";
// @ts-ignore
import { tw } from "@careinfo/tailwind";
import { useQueryClient } from "@tanstack/react-query";
import Modal from "../../../Reusable/Modal";
import UpdateContacts from "./UpdateContact";

const UpdateContactModal = ({
  isOpen,
  setIsOpen,
  id,
}: {
  isOpen: boolean;
  setIsOpen: (val: boolean) => void;
  id: string | number;
}) => {
  const queryClient = useQueryClient();

  return (
    <Modal isOpen={isOpen} setIsOpen={setIsOpen} title="Update Contact">
      <div className={tw`flex flex-col items-center w-[600px]`}>
        <UpdateContacts
          id={id}
          setIsOpen={setIsOpen}
          invalidateQuery={() =>
            queryClient.invalidateQueries({ queryKey: ["contacts"] })
          }
        />
      </div>
    </Modal>
  );
};

export default UpdateContactModal;
